/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';

/**
 * @StatusIcon
 *
 * Defines the Design Language System (DLS) Notifications Status Icon.
 *
 * ```typescript
 *    import {NotificationsStatusIcon} from '@ion/dls/src/types/types';
 *
 *    <NotificationsStatusIcon type={IconStatus.active} size={StatusIconSize.small} />
 *
 * ```
 */
const NotificationsStatusIcon = () => {
  return (
    <svg width='10' height='10' viewBox='0 0 10 10' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='5' cy='5' r='5' fill='#276BD8' />
    </svg>
  );
};

export default React.memo(NotificationsStatusIcon);
